import React from 'react'
import { forumEntryUrl } from '@configs'

/**
 * `/forum` → forum.judahs.io. `ExternalRedirect` 와 같은 모양이지만 주소를 **마운트 시점에** 고른다 —
 * 로그인돼 있으면 `/session/sso` 로 보내 로그인된 채로 착지시킨다 (FORUM_PLAN §11). 라우트 원소는
 * `useMemo` 안에서 한 번 만들어지므로 prop 으로 넘기면 첫 렌더의 로그인 상태에 고정된다.
 */
export const ForumRedirect = (): null => {
	React.useEffect(() => {
		window.location.replace(forumEntryUrl())
	}, [])

	return null
}
